import { Modal, Form, Input, Button, App } from 'antd';
import React, { useState } from 'react'
import { useGoodsGuigeAddMutation } from '../../store/ReactWebSiteApi';

function GoodsSpecAdd(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateAdd = (values) => {
        console.log('Received values of form: ', values);
        systemAdd(infoAdd).then((res) => {
            if (res.data.Status === 'success') {
                message.info('新增成功！');
                setOpen(false);
            }
            if (res.data.Status === "fail") {
                message.error('新增失败！'+res.data.Message)
            }
        })
        
    };
    const [infoAdd,setInfoAdd] = useState({
        egg_eg_id:props.egg_eg_id,
        egg_uid:localStorage.getItem('eu_id'),
        egg_e_id:localStorage.getItem('e_id'),
        egg_uname:localStorage.getItem('eu_name'),
        
    });
    const [systemAdd] = useGoodsGuigeAddMutation()
    return (
        <>
            <Button type='primary' onClick={() => {setOpen(true);}} style={{marginBottom:'10px'}}>新增规格</Button>
            <Modal
                width={1000}
                open={open}
                title='新增规格'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateAdd(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    
                }}
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name="goodsSpecAddForm"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 5 }}
                >
                    <Form.Item name="name" label='规格名称' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setInfoAdd(prevState=>({...prevState,egg_name:e.target.value}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default GoodsSpecAdd